import React from "react";
import { CheckCircle2, ExternalLinkIcon } from "lucide-react";
import { Badge, Button } from "@/components/ui";
import { useTranslation } from "react-i18next";
import { GoingStatusEnum } from "@/__generated__/graphql";
import { Student } from "@/types/Student";

export function StudentHeader({ student }: { student: Partial<Student> }) {
  const { studentOrganizationStatus } = student;
  const { name, crmUrl } = studentOrganizationStatus || {};

  const studentIsGoing = studentOrganizationStatus
    ? studentOrganizationStatus.goingStatus === GoingStatusEnum.Going
    : false;
  const { t } = useTranslation();

  return (
    <h2
      className="flex flex-wrap items-center gap-1 text-xl font-bold text-muted-2"
      data-testid="student-name"
    >
      <div className="flex items-center gap-1">
        <span>{name}</span>
        {studentIsGoing && (
          <Badge
            className="flex-shrink-0 rounded-xl border border-green-400 bg-green-100 px-0 pr-2 text-green-700 [&>svg]:size-4"
            data-testid="student-going-badge"
          >
            <CheckCircle2 className="ml-0.5 h-5 w-5" />
            <span className="text-[10px] leading-[10px] uppercase">
              {t("filters.fieldOptions.GOING")}
            </span>
          </Badge>
        )}
        {crmUrl?.length && (
          <Button
            variant="outline"
            size="icon"
            title={t("studentCard.openCRM", {
              firstName: name?.split(" ")[0] || "",
            })}
            className="size-auto flex-shrink-0 rounded-xl p-0.5"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              window.open(crmUrl, "_blank");
            }}
          >
            <ExternalLinkIcon className="size-4" />
          </Button>
        )}
      </div>
    </h2>
  );
}
